import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { RenderText } from './render-text';
import { RenderElement } from './render-element';
export const DisplayRichText = memo(({ content }) => {
    if (content.length === 0) {
        return _jsx("wbr", {});
    }
    return (_jsx(_Fragment, { children: content.map((child, index) => {
            if ('type' in child) {
                return (
                // eslint-disable-next-line react/no-array-index-key
                _jsx(RenderElement, { element: child, children: _jsx(DisplayRichText, { content: child.children }) }, index));
            }
            // eslint-disable-next-line react/no-array-index-key
            return _jsx(RenderText, { text: child }, index);
        }) }));
});
